import { Login, LoginLayout } from 'ui-classic-common-library';
import React from 'react';

import pkg from '../../../package.json';

const LoginModule = () => (
  <LoginLayout footerVersion={pkg.version} includeHeader={false}>
    <Login
      allowLegacyLogin
      onLoginSuccess={() => {
        window.location.href = '/';
      }}
    />
  </LoginLayout>
);

export default LoginModule;



// WEBPACK FOOTER //
// ./src/containers/Login/LoginModule.js